import { HelpTopic } from '../components/types';

import { checkInVideographer, afterCheckIn, shareVideo } from './attendee';

export const helpContent: HelpTopic[] = [
  {
    name: 'Attendee',
    slug: 'attendee',
    articles: [
      { slug: 'check-in', content: checkInVideographer },
      { slug: 'after-check-in', content: afterCheckIn },
      { slug: 'share-video', content: shareVideo },
    ],
  },
  // { name: 'Host', slug: 'host', articles: [] },
  // { name: 'Videographer', slug: 'videographer', articles: [] },
];
